import StyledLink from './StyledLink';

export default StyledLink;
